import { render } from "./VtoHotswapEdit.vue?vue&type=template&id=4623f37c"
import script from "./VtoHotswapEdit.vue?vue&type=script&lang=js"
export * from "./VtoHotswapEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__